module.exports = __webpack_public_path__ + "img/04-3-2业务持续性.47d8fd24.svg";